import { useMutation as e, useQuery as t, useQueryClient as n } from "@tanstack/react-query";
import { http as r, toListPage as i } from "@frontends/data-access-spg-api";
//#region src/lib/api/mappers.ts
function a(e) {
	let { account_check: t, activity_gate: n, balance_check: r, email_verify: i, grant_access: a, ib_check: o } = e;
	return {
		accountCheck: { referralLink: t.referral_link },
		emailVerify: {
			maxEmailAttempts: i.max_email_attempts,
			maxCodeAttempts: i.max_code_attempts,
			resendCooldownSeconds: i.resend_cooldown_seconds,
			codeLength: i.code_length,
			codeTtlMinutes: i.code_ttl_minutes
		},
		ibCheck: { partnerNodes: o.partner_nodes ?? {} },
		balanceCheck: r && { minBalanceUsd: r.min_balance_usd },
		activityGate: n && {
			metric: n.metric,
			threshold: n.threshold,
			windowDays: n.window_days,
			instruments: n.instruments,
			cooldownDays: n.cooldown_days
		},
		grantAccess: { inviteLinkTtlMinutes: a.invite_link_ttl_minutes }
	};
}
function o(e) {
	return {
		id: e.id,
		name: e.name,
		languages: e.languages ?? [],
		defaultLanguage: e.default_language,
		maxStepRetries: e.max_step_retries,
		steps: a(e.steps)
	};
}
function s(e) {
	let { accountCheck: t, activityGate: n, balanceCheck: r, emailVerify: i, grantAccess: a, ibCheck: o } = e;
	return {
		account_check: { referral_link: t.referralLink },
		email_verify: {
			max_email_attempts: i.maxEmailAttempts,
			max_code_attempts: i.maxCodeAttempts,
			resend_cooldown_seconds: i.resendCooldownSeconds,
			code_length: i.codeLength,
			code_ttl_minutes: i.codeTtlMinutes
		},
		ib_check: { partner_nodes: o.partnerNodes },
		balance_check: r && { min_balance_usd: r.minBalanceUsd },
		activity_gate: n && {
			metric: n.metric,
			threshold: n.threshold,
			window_days: n.windowDays,
			instruments: n.instruments,
			cooldown_days: n.cooldownDays
		},
		grant_access: { invite_link_ttl_minutes: a.inviteLinkTtlMinutes }
	};
}
function c(e) {
	return {
		name: e.name,
		languages: e.languages,
		default_language: e.defaultLanguage,
		max_step_retries: e.maxStepRetries,
		steps: s(e.steps)
	};
}
//#endregion
//#region src/lib/api/entryFlowsApi.ts
async function l(e) {
	let { data: t } = await r.get("/entry-flows", { signal: e });
	return t.map(o);
}
async function u(e, t) {
	let { data: n } = await r.get(`/entry-flows/${encodeURIComponent(e)}`, { signal: t });
	return o(n);
}
async function d(e) {
	let { data: t } = await r.post("/entry-flows", c(e));
	return o(t);
}
async function f(e, t) {
	let { data: n } = await r.put(`/entry-flows/${encodeURIComponent(e)}`, c(t));
	return o(n);
}
async function p(e) {
	let { data: t } = await r.get("/languages", { signal: e });
	return t;
}
async function m(e) {
	await r.delete(`/entry-flows/${encodeURIComponent(e)}`);
}
//#endregion
//#region src/lib/queries.ts
var h = {
	all: ["entry-flows"],
	list: () => [...h.all, "list"],
	detail: (e) => [
		...h.all,
		"detail",
		e
	]
};
function g(e, n) {
	return t({
		queryKey: h.list(),
		queryFn: ({ signal: e }) => l(e),
		select: (t) => i(t.filter((e) => e.name.toLowerCase().includes(n.query.toLowerCase())), e, (e, t) => e[t])
	});
}
function _(e) {
	return t({
		queryKey: h.detail(e),
		queryFn: ({ signal: t }) => u(e, t)
	});
}
function v() {
	return t({
		queryKey: ["languages"],
		queryFn: ({ signal: e }) => p(e),
		staleTime: Infinity
	});
}
function y() {
	return t({
		queryKey: h.list(),
		queryFn: ({ signal: e }) => l(e)
	});
}
//#endregion
//#region src/lib/mutations.ts
function b() {
	let t = n();
	return e({
		mutationFn: d,
		onSuccess: () => t.invalidateQueries({ queryKey: h.list() })
	});
}
function x() {
	let t = n();
	return e({
		mutationFn: ({ id: e, flow: t }) => f(e, t),
		onSuccess: (e) => (t.setQueryData(h.detail(e.id), e), t.invalidateQueries({ queryKey: h.list() }))
	});
}
function S() {
	let t = n();
	return e({
		mutationFn: m,
		onSuccess: (e, n) => (t.removeQueries({ queryKey: h.detail(n) }), t.invalidateQueries({ queryKey: h.list() }))
	});
}
//#endregion
export { h as entryFlowsQueryKeys, y as useAllEntryFlowsQuery, b as useCreateEntryFlowMutation, S as useDeleteEntryFlowMutation, _ as useEntryFlowQuery, g as useEntryFlowsQuery, v as useLanguagesQuery, x as useUpdateEntryFlowMutation };
